<template>
  <div class="modal-mask">
    <TopAppBar
      :leftBtnMode="'arrow_back'"
      :title="$t('3794')"
      :leftBtnMethod="handleClose"
      staticMode="true"
    />

    <div class="pda-16">
      <div class="t-headline9 mt3">
        {{ $t("3795") }}
      </div>
      <div class="t-body3 mgt-6 t-color-bodyGrayA">
        {{ $t("3796") }}
      </div>

      <!-- 사유 선택 -->
      <div class="mgt-24">
        <div
          v-for="(item, i) in list"
          :key="i"
          class="pda-16 pdt-14 pdb-14 mgb-8 b-radius4"
          :class="item.value === selected ? 'bg-quizBlack' : 'bg-quizGray'"
        >
          <div class="mdc-form-field" v-if="item.value !== 'OTHERS'">
            <div class="mdc-radio radio-white">
              <input
                class="mdc-radio__native-control"
                type="radio"
                :value="item.value === selected"
                :id="`radio_${item.value}`"
                @click="setSelected(item.value)"
                @keypress="setSelected(item.value)"
                tabindex="0"
                name="reason"
              />
              <div class="mdc-radio__background">
                <div class="mdc-radio__outer-circle"></div>
                <div class="mdc-radio__inner-circle"></div>
              </div>
            </div>
            <label
              :for="`radio_${item.value}`"
              class="t-body1"
              :class="
                item.value === selected
                  ? 't-color-whiteHigh2'
                  : 't-color-quizBlack'
              "
            >
              {{ handleLangWithdrawList(item.value) }}
            </label>
          </div>

          <!-- 기타 사유 -->
          <div
            v-else
            class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full align-items-center"
          >
            <div class="mdc-radio radio-white">
              <input
                class="mdc-radio__native-control"
                type="radio"
                :value="selected === 4"
                :id="`radio_${4}`"
                @click="setSelected(item.value, 'ETC')"
                @keypress="setSelected(item.value, 'ETC')"
                tabindex="0"
                name="reason"
              />
              <div class="mdc-radio__background">
                <div class="mdc-radio__outer-circle"></div>
                <div class="mdc-radio__inner-circle"></div>
              </div>
            </div>
            <div
              class="d-flex flex-column mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full"
              :class="[
                { 'mdc-text-field--invalid': !commentValidation },
                { 'mdc-text-field--disabled': !selectedEtc },
              ]"
              id="reason-input"
            >
              <i class="material-icons mdc-text-field__icon">
                {{ validIcon }}
              </i>
              <input
                type="text"
                class="mdc-text-field__input input-color"
                maxlength="100"
                autocomplete="off"
                :value="comment"
                @input="handleComment"
                :disabled="!selectedEtc"
              />
              <div class="mdc-notched-outline">
                <div
                  class="mdc-notched-outline__leading"
                  :class="{ 'selected-outline': selected === 'OTHERS' }"
                ></div>
                <div
                  class="mdc-notched-outline__notch"
                  :class="{ 'selected-outline': selected === 'OTHERS' }"
                >
                  <label
                    for="tf-outlined"
                    class="mdc-floating-label"
                    :class="
                      selected === 'OTHERS'
                        ? 't-color-whiteHigh2'
                        : selected === 'OTHERS' && !commentValidation
                        ? 't-color-secondaryBtnText'
                        : ''
                    "
                  >
                    {{ $t("3802") }}
                  </label>
                </div>
                <div
                  class="mdc-notched-outline__trailing"
                  :class="{ 'selected-outline': selected === 'OTHERS' }"
                ></div>
              </div>
              <div
                class="pdl-10 mgt-1 t-helper text-helper t-color-textfieldActive"
              ></div>
            </div>
          </div>
        </div>
      </div>

      <!-- Buttons -->
      <div class="mgt-50">
        <button
          class="mdc-button mdc-button--raised btn-red mr8"
          @click="next"
          @keypress="next"
        >
          {{ $t("3804") }}
        </button>
        <button
          class="mdc-button btn-white t-color-secondaryBtnText"
          @click="handleClose()"
          @keypress="handleClose()"
          type="button"
          tabindex="0"
        >
          {{ $t("3805") }}
        </button>
      </div>
    </div>
  </div>
</template>
  
<script>
import { MDCTextField } from "@material/textfield";
import { MDCRipple } from "@material/ripple";
import { MDCRadio } from "@material/radio";

import memberApi from "@/api/memberApi";
import degreeApi from "@/api/degreeApi";
import checklistApi from "@/api/checklistApi";

export default {
  name: "ReasonChoice",

  components: {
    TopAppBar: () => import("@/components/TopAppBar.vue"),
  },

  data() {
    return {
      data: null,
      list: null,
      selected: null,
      selectedEtc: false,
      comment: "",
      commentTextField: "",
      validIcon: "",
      commentValidation: true,
    };
  },

  watch: {
    selectedEtc: function (val) {
      if (!val) {
        this.handleCommentValidation();
      }
    },
  },

  mounted() {
    if (this.$route.params.data) {
      this.data = this.$route.params.data;
    } else {
      this.$router.go(-1);
    }
    this.getList();
    setTimeout(() => {
      this.setMaterialUi();
    }, [100]);
  },

  methods: {
    setMaterialUi() {
      const reasonInput = document.querySelector("#reason-input");
      const mdcButtonClass = document.querySelectorAll(".mdc-button");
      if (reasonInput) {
        this.commentTextField = new MDCTextField(reasonInput);
        this.commentTextField.useNativeValidation = true;
        [].map.call(mdcButtonClass, function (el) {
          new MDCRipple.attachTo(el);
        });
      }
      // === MDC 라디오 초기화 추가 ===
      const radios = this.$el.querySelectorAll('.mdc-radio');
      console.log("radios", radios);
      radios.forEach(radio => {
        new MDCRadio(radio);
      });
    },

    handleComment(e) {
      this.comment = e.target.value;
      if (this.comment.length) {
        this.handleCommentValidation();
      }
    },

    handleCommentValidation() {
      this.commentValidation = !(this.comment.length === 0 && this.selectedEtc);
    },

    handleClose() {
      this.$router.go(-1);
    },

    // 사유 리스트 다국어 처리
    handleLangWithdrawList(value) {
      switch (value) {
        case "SPAM":
          return this.$t("3797");

        case "CURSE":
          return this.$t("3798");

        case "COPYRIGHT_INFRINGE":
          return this.$t("3799");

        case "PERSONAL_INFO":
          return this.$t("3800");

        case "IRRELEVANT_CONTENTS":
          return this.$t("3801");

        default:
          break;
      }
    },

    // GET : 사유 리스트
    async getList() {
      try {
        const listResult = await memberApi.getReportReasonList();
        if (listResult) {
          const responseList = listResult.data.data;
          const filteredResponseList = responseList.filter(
            (listItem) => listItem
          );
          this.list = filteredResponseList;
        }
      } catch (error) {
        // console.log("GET LIST ERR : ", error);
      }
    },

    // 답안 설정(set answer)
    setSelected(value, type) {
      if (type === "ETC") {
        this.selectedEtc = true;
      } else {
        this.selectedEtc = false;
        this.comment = "";
      }
      this.selected = value;
      // 라디오 UI 갱신
      this.$nextTick(() => {
        this.setMaterialUi();
      });
    },

    // 다음 처리
    async next() {
      if (this.selected === null) {
        this.handleCommentValidation();
        return this.$snackOpen({
          contents: this.$t("3806"),
        });
      }

      if (this.selected === "OTHERS" && this.comment.length === 0) {
        this.handleCommentValidation();
        return this.$snackOpen({
          contents: this.$t("3876"),
        });
      }

      const confirmResult = await this.$confirm({
        title: this.$t("3790"),
        content: this.$t("3791"),
        accept: this.$t("3792"),
        cancel: this.$t("3793"),
      });

      if (confirmResult) {
        const params = {
          reason: {},
        };
        if (this.selected === "OTHERS" && this.comment.length > 0) {
          params.comment = this.comment;
        }
        const selected = this.list.find(
          (listItem) => listItem.value === this.selected
        );
        params.reason = selected;

        try {
          // 요청 파라미터 정리
          let requestApi = null;

          // if (this.$route.query.type === "COMMENT") {
          //   requestApi = boardApi.reportComment({
          //     ...params,
          //     boardId: this.data.boardDto.identifier,
          //     postId: this.data.id,
          //     id: this.$route.params.commentData.id,
          //   });
          // }

          if (this.$route.query.type === "REVIEW") {
            requestApi = degreeApi.reportReview({
              ...params,
              degreeId: this.$route.params.degreeId,
              reviewId: this.data.id,
            });
          }

          if (this.$route.query.type === "CHECKLIST_COMMENT") {
            requestApi = checklistApi.reportComment(
              {
                ...params,
                postId: this.$route.params.data.postId,
              },
              this.$route.params.data.id
            );
          }

          const result = await requestApi;
          if (result) {
            // 요청 이후 처리
            this.$router.go(-1);
            this.$snackOpen({
              contents: this.$t("3807"),
            });
          }
        } catch (error) {
          // console.log("Report error : ", error);
        }
      }
    },
  },
};
</script>
  
  
<style scoped>
.warning {
  color: #fc5356 !important;
}

.selected-outline {
  border-color: var(--WhiteHigh2) !important;
}

.input-color {
  caret-color: var(--WhiteHigh2) !important;
  color: var(--WhiteHigh2) !important;
}

.mdc-text-field .mdc-text-field__input {
  caret-color: var(--WhiteHigh2) !important;
}
</style>